import React from 'react';
import { useNavigate } from 'react-router-dom';

const PayCreditButton = ({ isLoading, disabled }) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/customer/pay-credit')}
      disabled={isLoading || disabled}
      className={`px-4 py-2 rounded-lg text-white ${
        disabled
          ? 'bg-gray-400 cursor-not-allowed'
          : 'bg-green-600 hover:bg-green-700'
      }`}
    >
      {isLoading
        ? 'Processing…'
        : disabled
        ? 'No Outstanding Credit'
        : 'Pay Credit'}
    </button>
  );
};

export default PayCreditButton;
